import { workbookFields } from "helpers/constants";

export const DEFAULT_WORKBOOK_FIELD_ORDER = [
	"Purpose",
	"Procedure",
	"PossibleHazards",
	"AdditionalPPE",
	"Specification",
	"ContaminationControl",
	"OtherInformation",
	"Isolations",
	"CorrectiveActions",
	"Controls",
	"CustomField1",
	"CustomField2",
	"CustomField3",
];

export const parseWorkbookFieldOrder = (json) => {
	if (!json) return DEFAULT_WORKBOOK_FIELD_ORDER;

	try {
		const parsed = JSON.parse(json);
		const isValid =
			Array.isArray(parsed) &&
			parsed.length === DEFAULT_WORKBOOK_FIELD_ORDER.length &&
			new Set(parsed).size === DEFAULT_WORKBOOK_FIELD_ORDER.length &&
			parsed.every((key) => DEFAULT_WORKBOOK_FIELD_ORDER.includes(key));

		return isValid ? parsed : DEFAULT_WORKBOOK_FIELD_ORDER;
	} catch {
		return DEFAULT_WORKBOOK_FIELD_ORDER;
	}
};

export const applyReorder = (order, sourceIndex, destinationIndex) => {
	const result = [...order];
	const [moved] = result.splice(sourceIndex, 1);
	result.splice(destinationIndex, 0, moved);
	return result;
};

const toFieldName = (key) => key.charAt(0).toLowerCase() + key.slice(1);

export const orderedWorkbookFields = (customCaptions, orderJson) => {
	const fieldsByName = Object.fromEntries(
		workbookFields(customCaptions).map((field) => [field.name, field])
	);

	return parseWorkbookFieldOrder(orderJson)
		.map((key) => fieldsByName[toFieldName(key)])
		.filter(Boolean);
};
